/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfUser } from '../../models/data-page-of-user';

export interface UserSearch$Params {
  practiceId: string | null;
  pageNumber?: number;
  pageSize?: number;
  searchText?: string | null;
  SortByColumn?: string | null;
  SortByDirection?: string | null;
}

export function userSearch(http: HttpClient, rootUrl: string, params: UserSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfUser>> {
  const rb = new RequestBuilder(rootUrl, userSearch.PATH, 'get');
  if (params) {
    rb.path('practiceId', params.practiceId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('searchText', params.searchText, {});
    rb.query('SortByColumn', params.SortByColumn, {});
    rb.query('SortByDirection', params.SortByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfUser>;
    })
  );
}

userSearch.PATH = '/api/practices/{practiceId}/users';
